export default class Bow {
    constructor(
        public Name: string,
        public Level: number,
        public Description: string,
        public MinBaseDamage: number,
        public MaxBaseDamage: number,
        public TimeToFullPower = new Date(0, 0, 0, 0, 0, 1, 800),
        public MaxArrows: number,
        public Image: string,
        public Cost: number,
        public IsPulled: boolean = false) { }
        
}

export class Bows {
    private static HasLoaded = false;
    private static HasCreated = false;

    static BasicBow: Bow = new Bow("BasicBow", 1, "A basic craft of wood and string.",
        2, 8,
        new Date(0, 0, 0, 0, 0, 2, 0),
        2,
        'basicbow1.png',
        0,
        false);

    static StrengthenBow: Bow = new Bow("StrengthenBow", 3, "Strengthened by applying a layer of strong wood.",
        6, 15,
        new Date(0, 0, 0, 0, 0, 1, 700),
        2,
        'strengthenBow1.png',
        400,
        false);

    static ReinforcedBow: Bow = new Bow("ReinforcedBow", 4, "Reinforced with layers of wood,this bow is capable of producing more force.",
        10, 25,
        new Date(0, 0, 0, 0, 0, 1, 700),
        2,
        'reinforcedBow.png',
        1000,
        false);

    static SteelBow: Bow = new Bow("SteelBow", 5, "A special craft of wood and steel,making it stronger and quicker",
        30, 60,
        new Date(0, 0, 0, 0, 0, 1, 600),
        3,
        'steelBow.png',
        2500,
        false);

    static DevBow: Bow = new Bow("DevBow", 1, "", 9999, 15000, new Date(0, 0, 0, 0, 0, 0, 1), 9999, 'DevBow1.png', 0, false);

    static AllBows: Array<Bow> = [Bows.BasicBow, Bows.StrengthenBow, Bows.ReinforcedBow, Bows.SteelBow, Bows.DevBow];

    public static GetBow(name: string): Bow | undefined {
        return this.AllBows.find(b => b.Name == name);
    }

    public static PreloadAllBows(scene) {
        if (Bows.HasLoaded) {
            return;
        }

        let bowConfig: Phaser.Types.Loader.FileTypes.ImageFrameConfig =
        {
            frameWidth: 312,
            frameHeight: 258
        };

        this.AllBows.forEach(bow => {
            scene.load.spritesheet(`bow_${bow.Name}`, 'images/Bows/' + bow.Image, bowConfig);
        });
        Bows.HasLoaded = true;
    }

    public static CreateAllBowsAnimation(scene) {
        if (Bows.HasCreated) {
            return;
        }

        this.AllBows.forEach(bow => {
            let bowKey = `bow_${bow.Name}`;
            scene.anims.create({
                key: `shootBow_${bowKey}`,
                frames: scene.anims.generateFrameNumbers(bowKey, { start: 0, end: 2 }),
                repeat: 0,
                duration: bow.TimeToFullPower.getSeconds() * 1000 + bow.TimeToFullPower.getMilliseconds()
            });

            scene.anims.create({
                key: `releaseBow_${bowKey}`,
                frames: scene.anims.generateFrameNumbers(bowKey, { start: 3, end: 5 }),
                repeat: 0,
                duration: 200
            });
        });
        Bows.HasCreated = true;
    }

}